// @ts-nocheck
import * as Types from '../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../../../fragments/commonFragments.generated';
import { MaterialCatalog_AssetFragmentDoc } from '../../../../../../libraries/material-catalog/MaterialCatalog.generated';
import { ProductCard_MaterialVariantFragmentDoc } from './ProductCard.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DefineReplacementMetadataQueryVariables = Types.Exact<{
  projectItemId: Types.Scalars['ID']['input'];
}>;


export type DefineReplacementMetadataQuery = { __typename?: 'Query', projectItem: { __typename?: 'ProjectItem', id: string, item: { __typename?: 'Item', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string } }, materialBrands: Array<{ __typename?: 'MaterialBrand', id: string, name: string }> };

export type DefineReplacementMaterialVariantQueryVariables = Types.Exact<{
  materialVariantId: Types.Scalars['ID']['input'];
}>;


export type DefineReplacementMaterialVariantQuery = { __typename?: 'Query', materialVariant: { __typename?: 'MaterialVariant', id: string, modelNumber?: string | null | undefined, manufacturerUrl?: string | null | undefined, images: Array<{ __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, version: string, url: string, fileName?: string | null | undefined, contentType: string, downloadUrl: string, attachmentUrl: string, previewUrl?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'] } | null | undefined }>, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, description?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string } | null | undefined } } };

export type DefineReplacement_MaterialVariantFragment = { __typename?: 'MaterialVariant', id: string, modelNumber?: string | null | undefined, manufacturerUrl?: string | null | undefined, images: Array<{ __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, version: string, url: string, fileName?: string | null | undefined, contentType: string, downloadUrl: string, attachmentUrl: string, previewUrl?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'] } | null | undefined }>, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, description?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string } | null | undefined } };

export type DefineReplacement_SaveMaterialListingMutationVariables = Types.Exact<{
  input: Types.SaveMaterialListingInput;
}>;


export type DefineReplacement_SaveMaterialListingMutation = { __typename?: 'Mutation', saveMaterialListing: { __typename?: 'MaterialListing', id: string, materialVariants: Array<{ __typename?: 'MaterialVariant', id: string, modelNumber?: string | null | undefined, manufacturerUrl?: string | null | undefined, displayName: string, images: Array<{ __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, version: string, url: string, fileName?: string | null | undefined, contentType: string, downloadUrl: string, attachmentUrl: string, previewUrl?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'] } | null | undefined }>, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, description?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, version: string, url: string, fileName?: string | null | undefined, contentType: string, downloadUrl: string, attachmentUrl: string, previewUrl?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'] } | null | undefined } | null | undefined }> } };

export const DefineReplacement_MaterialVariantFragmentDoc = gql`
    fragment DefineReplacement_MaterialVariant on MaterialVariant {
  id
  modelNumber
  manufacturerUrl
  images {
    id
    sortOrder
    asset {
      ...MaterialCatalog_Asset
    }
  }
  listing {
    id
    name
    description
    brand {
      id
    }
  }
}
    ${MaterialCatalog_AssetFragmentDoc}`;
export const DefineReplacementMetadataDocument = gql`
    query DefineReplacementMetadata($projectItemId: ID!) {
  projectItem(id: $projectItemId) {
    id
    item {
      ...Named
    }
    unitOfMeasure {
      ...Named
    }
  }
  materialBrands(filter: {}) {
    id
    name
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useDefineReplacementMetadataQuery__
 *
 * To run a query within a React component, call `useDefineReplacementMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefineReplacementMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefineReplacementMetadataQuery({
 *   variables: {
 *      projectItemId: // value for 'projectItemId'
 *   },
 * });
 */
export function useDefineReplacementMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DefineReplacementMetadataQuery, DefineReplacementMetadataQueryVariables> & ({ variables: DefineReplacementMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DefineReplacementMetadataQuery, DefineReplacementMetadataQueryVariables>(DefineReplacementMetadataDocument, options);
      }
export function useDefineReplacementMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DefineReplacementMetadataQuery, DefineReplacementMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DefineReplacementMetadataQuery, DefineReplacementMetadataQueryVariables>(DefineReplacementMetadataDocument, options);
        }
// @ts-ignore
export function useDefineReplacementMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DefineReplacementMetadataQuery, DefineReplacementMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefineReplacementMetadataQuery, DefineReplacementMetadataQueryVariables>;
export function useDefineReplacementMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefineReplacementMetadataQuery, DefineReplacementMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefineReplacementMetadataQuery | undefined, DefineReplacementMetadataQueryVariables>;
export function useDefineReplacementMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefineReplacementMetadataQuery, DefineReplacementMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DefineReplacementMetadataQuery, DefineReplacementMetadataQueryVariables>(DefineReplacementMetadataDocument, options);
        }
export type DefineReplacementMetadataQueryHookResult = ReturnType<typeof useDefineReplacementMetadataQuery>;
export type DefineReplacementMetadataLazyQueryHookResult = ReturnType<typeof useDefineReplacementMetadataLazyQuery>;
export type DefineReplacementMetadataSuspenseQueryHookResult = ReturnType<typeof useDefineReplacementMetadataSuspenseQuery>;
export type DefineReplacementMetadataQueryResult = ApolloReactCommon.QueryResult<DefineReplacementMetadataQuery, DefineReplacementMetadataQueryVariables>;
export const DefineReplacementMaterialVariantDocument = gql`
    query DefineReplacementMaterialVariant($materialVariantId: ID!) {
  materialVariant(id: $materialVariantId) {
    ...DefineReplacement_MaterialVariant
  }
}
    ${DefineReplacement_MaterialVariantFragmentDoc}`;

/**
 * __useDefineReplacementMaterialVariantQuery__
 *
 * To run a query within a React component, call `useDefineReplacementMaterialVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefineReplacementMaterialVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefineReplacementMaterialVariantQuery({
 *   variables: {
 *      materialVariantId: // value for 'materialVariantId'
 *   },
 * });
 */
export function useDefineReplacementMaterialVariantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DefineReplacementMaterialVariantQuery, DefineReplacementMaterialVariantQueryVariables> & ({ variables: DefineReplacementMaterialVariantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DefineReplacementMaterialVariantQuery, DefineReplacementMaterialVariantQueryVariables>(DefineReplacementMaterialVariantDocument, options);
      }
export function useDefineReplacementMaterialVariantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DefineReplacementMaterialVariantQuery, DefineReplacementMaterialVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DefineReplacementMaterialVariantQuery, DefineReplacementMaterialVariantQueryVariables>(DefineReplacementMaterialVariantDocument, options);
        }
// @ts-ignore
export function useDefineReplacementMaterialVariantSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DefineReplacementMaterialVariantQuery, DefineReplacementMaterialVariantQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefineReplacementMaterialVariantQuery, DefineReplacementMaterialVariantQueryVariables>;
export function useDefineReplacementMaterialVariantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefineReplacementMaterialVariantQuery, DefineReplacementMaterialVariantQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefineReplacementMaterialVariantQuery | undefined, DefineReplacementMaterialVariantQueryVariables>;
export function useDefineReplacementMaterialVariantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefineReplacementMaterialVariantQuery, DefineReplacementMaterialVariantQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DefineReplacementMaterialVariantQuery, DefineReplacementMaterialVariantQueryVariables>(DefineReplacementMaterialVariantDocument, options);
        }
export type DefineReplacementMaterialVariantQueryHookResult = ReturnType<typeof useDefineReplacementMaterialVariantQuery>;
export type DefineReplacementMaterialVariantLazyQueryHookResult = ReturnType<typeof useDefineReplacementMaterialVariantLazyQuery>;
export type DefineReplacementMaterialVariantSuspenseQueryHookResult = ReturnType<typeof useDefineReplacementMaterialVariantSuspenseQuery>;
export type DefineReplacementMaterialVariantQueryResult = ApolloReactCommon.QueryResult<DefineReplacementMaterialVariantQuery, DefineReplacementMaterialVariantQueryVariables>;
export const DefineReplacement_SaveMaterialListingDocument = gql`
    mutation DefineReplacement_SaveMaterialListing($input: SaveMaterialListingInput!) {
  saveMaterialListing(input: $input) {
    id
    materialVariants {
      ...DefineReplacement_MaterialVariant
      ...ProductCard_MaterialVariant
    }
  }
}
    ${DefineReplacement_MaterialVariantFragmentDoc}
${ProductCard_MaterialVariantFragmentDoc}`;

/**
 * __useDefineReplacement_SaveMaterialListingMutation__
 *
 * To run a mutation, you first call `useDefineReplacement_SaveMaterialListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefineReplacement_SaveMaterialListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [defineReplacementSaveMaterialListingMutation, { data, loading, error }] = useDefineReplacement_SaveMaterialListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefineReplacement_SaveMaterialListingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DefineReplacement_SaveMaterialListingMutation, DefineReplacement_SaveMaterialListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DefineReplacement_SaveMaterialListingMutation, DefineReplacement_SaveMaterialListingMutationVariables>(DefineReplacement_SaveMaterialListingDocument, options);
      }
export type DefineReplacement_SaveMaterialListingMutationHookResult = ReturnType<typeof useDefineReplacement_SaveMaterialListingMutation>;
export type DefineReplacement_SaveMaterialListingMutationResult = ApolloReactCommon.MutationResult<DefineReplacement_SaveMaterialListingMutation>;